import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const contentWrapperStyle = css`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const formSectionStyle = css`
  flex: 2;
  overflow-y: auto;
  background-color: ${theme.colors.neutral[10]};
`;

export const sidePanelStyle = css`
  flex: 1;
  overflow-y: auto;
  border-left: 1px solid ${theme.colors.neutral20};
  padding-left: ${theme.spacing(2)};
`;
